import { Component, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { environment } from '../../../environments/environment';

// BUILD_TIME is a post-compile placeholder: the literal '__BUILD_TIME__' is committed
// and rewritten to new Date().toISOString() by scripts/build.ts after the Angular build.
// Dev builds (ng serve) stay unstamped — see the guard on buildTime below.
const BUILD_TIME = '__BUILD_TIME__';

@Component({
    standalone: true,
    selector: '[app-footer]',
    template: ` <div class="footer-start">
        </div>
        <div class="footer-right">
            <span>V0.0.62</span>
            @if (showBuildTime) {
                <span class="ml-2 text-sm opacity-70">· {{ buildTime }}</span>
            }
        </div>`,
    host: {
        class: 'layout-footer'
    }
})
export class AppFooter {
    layoutService = inject(LayoutService);

    // Show the build timestamp on every non-production environment (LOCAL DEV,
    // APEXDEV, etc.) so testers can tell which build they're on. Hidden on PROD.
    showBuildTime = environment.envName !== 'PROD';

    // Unstamped dev builds carry the literal placeholder (not a valid date); show 'dev build'.
    buildTime = isNaN(new Date(BUILD_TIME).getTime()) ? 'dev build' : BUILD_TIME;
}
